import React from 'react';
export const accordionData = [
  {
    question: `How do I access the Oddbods books?`,
    answer: `Simply sign up on SplashLearn to get access to all the Oddbods books.`,
    openState: false,
  },
  {
    question: `What is SplashLearn?`,
    answer: `SplashLearn is a game-based PreK-5 learning experience loved by over 40 million children. It's the perfect balance of learning and game-play that your little one needs to build math and reading confidence.`,
    openState: false,
  },
  {
    question: `Which grades does SplashLearn cover?`,
    answer: `SplashLearn offers a curriculum-aligned, game-based learning experience for Pre-Kindergarten to Grade 5`,
    openState: false,
  },
  {
    question: `Is it free?`,
    answer: `The Oddbods books come bundled within the SplashLearn program. We offer a 7-day free trial, after which you can choose a plan that works for you. Our plans start from $5 per month.`,
    openState: false,
  },
  {
    question: `Which devices are compatible with SplashLearn?`,
    answer: `You can access SplashLearn on your desktop, tablet, or smartphone.`,
    openState: false,
  },
];
